module.exports = __webpack_public_path__ + "static/media/plootus-p(2).a9d81b2a.png";